import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll() {
    return await requestWrapper(null, 'GET', `/classifier_levels`);
  },
  async create(lvl) {
    return await requestWrapper(null, 'POST', '/classifier_levels', null, lvl);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/classifier_levels/${id}`);
  },
  async update(lvl) {
    return await requestWrapper(null, 'PUT', `/classifier_levels/${lvl.id}`, null, lvl);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/classifier_levels/${id}`);
  },
};
